import * as yup from 'yup';

export const RetornoTaesaSchema = yup.object({
  declaracao: yup.bool().oneOf([true], 'Atenção, Clique em Declaração'),
});

export const RetornoTaesaInitialValues = {
  declaracao: false,
};
